<div>
  <app-weee-treatment-standard-mandatory-filters
    (search)="searchData($event)">
  </app-weee-treatment-standard-mandatory-filters>
  <mat-divider></mat-divider>
  <app-weee-treatment-standard-mandatory-map-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [data]="data">
  </app-weee-treatment-standard-mandatory-map-chart>
</div>
